/* eslint react/jsx-indent: 1 */
/* eslint react/jsx-indent-props: 1 */
/* eslint react/no-unused-state: 1 */
/* eslint no-undef: 1 */

import 'react-dates/initialize';
import React from 'react';
import moment from 'moment';
import { Logger } from 'aws-amplify';
import {
  DropDown, PrimaryButton, Pulse
} from 'wf-react-component-library';
import currencyFormatter from '../utilities/currency-formatter';
import PurchaseOrderItemDetails from './PurchaseOrderItemDetails';
import { postPurchaseOrder } from '../services/api/ConfirmOrderApiService';
import { deletePurchaseOrder } from '../services/api/OCSApiService';
import { getPurchaseOrderItemDetails, getPurchaseOrderHeaders } from '../services/api/P3ApiService';
import checkmark from '../icons/checkmark.svg';
import matched from '../icons/matched.svg';
import ConfirmationModal from './ConfirmationModal';
import compareP3Data from '../validation/compare-p3-results';

import './PurchaseOrderDetails.scss';

const logger = new Logger('PurchaseOrderDetails.js');

class PurchaseOrderDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPurchaseOrder: null,
      orderValidations: [],
      orderHeaders: {},
      vendorName: 'Nicole',
      selectedPurchaseOrders: [], //Store PO Ids for POs selected for Bulk Approve
      filterOptions: {
        "0": "All",
        "1": "No Vendor Changes",
        "2": "Vendor Changes"
      },
      filteredPurchaseOrders: this.props.purchaseOrderDetails,
      selectedFilterOption: 0,
      showConfirmationModal: false,
      isSaving: false,
    };

    this.formatDate = this.formatDate.bind(this);
    this.getCustomerName = this.getCustomerName.bind(this);
    this.showPurchaseOrderItems = this.showPurchaseOrderItems.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleApprove = this.handleApprove.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.formatToP3JSON = this.formatToP3JSON.bind(this);
    this.savePurchaseOrderForBulkApprove = this.savePurchaseOrderForBulkApprove.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleBulkApprove = this.handleBulkApprove.bind(this);
    this.cancelConfirmationModal = this.cancelConfirmationModal.bind(this);
    this.hideShowConfirmationModal = this.hideShowConfirmationModal.bind(this);
  }

  componentDidUpdate = (prevProps) => {
    const {searchId } = this.props;
    if (prevProps.searchId !== searchId) {
      this.setState({
        filteredPurchaseOrders: this.props.purchaseOrderDetails,
        selectedFilterOption: 0,
        showConfirmationModal: false,
        isSaving: false
      });
    }
  }

  formatDate = (myDt) => {
    const dt = moment(myDt);
    return dt.format('MM/DD/YYYY');
  }

  getCustomerName = (customerCode) => {
    const { customerDetails } = this.props;
    return customerDetails.filter((customer) => customer.code === customerCode)[0].description;
  }

  showPurchaseOrderItems = (selectedPurchaseOrder) => {
    this.setState({ orderValidations: {} })
    const { purchaseOrderDetails, vendorDetails } = this.props;

    let purchaseOrderItemDetails = null;
    let selectedPurchaseOrderDetails = null;
    let vendorName = null;
    let buyerId = null;

    if (selectedPurchaseOrder !== null) {
      purchaseOrderItemDetails = purchaseOrderDetails.filter((po) => selectedPurchaseOrder.toString() === po.poId.toString())[0].poDetail;
      selectedPurchaseOrderDetails = purchaseOrderDetails.filter((po) => selectedPurchaseOrder.toString() === po.poId.toString())[0];

      getPurchaseOrderItemDetails(selectedPurchaseOrderDetails.poId)
        .then((p3PurchaseOrderDetails) => {
          const orderValidations = compareP3Data(selectedPurchaseOrderDetails.poDetail, p3PurchaseOrderDetails);
          this.setState({ orderValidations });
        })
        .then(() => {
          getPurchaseOrderHeaders(selectedPurchaseOrderDetails.poId)
            .then((orderHeaders) => {
              this.setState({ orderHeaders });
            });
        });

      const vendorCode = purchaseOrderDetails.filter((po) => selectedPurchaseOrder.toString() === po.poId.toString())[0].vendorId;
      vendorName = vendorDetails.filter((vendor) => vendor.code === vendorCode)[0].description;
      buyerId = purchaseOrderDetails.filter((po) => selectedPurchaseOrder.toString() === po.poId.toString())[0].buyerId;
    }
    
    this.setState({
      selectedPurchaseOrder, purchaseOrderItemDetails, vendorName, selectedPurchaseOrderDetails, buyerId,
    });
  }

  closeModal = () => {
    this.setState({ selectedPurchaseOrder: null, purchaseOrderItemDetails: null});
  }

  formatToP3JSON = (selectedPurchaseOrderDetails) => {    
    const { currentUser } = this.props;
    if (selectedPurchaseOrderDetails !== null){
      var P3PoJson = {};
      P3PoJson.poId = selectedPurchaseOrderDetails.poId; 
      P3PoJson.pickupNumber = selectedPurchaseOrderDetails.pickupNumber;
      //formating date to ISO 8061 without milliseconds for P3 to work. 
      P3PoJson.loadDate = new Date(selectedPurchaseOrderDetails.loadDate).toISOString().split('.')[0]+"Z";
      P3PoJson.arrivalDate = new Date(selectedPurchaseOrderDetails.arrivalDate).toISOString().split('.')[0]+"Z";
      P3PoJson.createdBy = selectedPurchaseOrderDetails.createdBy;
      P3PoJson.createdDate = new Date(selectedPurchaseOrderDetails.createdDate).toISOString().split('.')[0]+"Z";
      P3PoJson.coolerCode = selectedPurchaseOrderDetails.coolerCode;
      P3PoJson.updateBuyer = currentUser; 
      P3PoJson.statusCode = 'B';
      P3PoJson.note = selectedPurchaseOrderDetails.note;
      P3PoJson.vendorNote = selectedPurchaseOrderDetails.vendorNote;
      P3PoJson.poDetails = [];
      P3PoJson.poDetails = selectedPurchaseOrderDetails.poDetail.map(pod => {       
        return {
          'id':pod.poDetailId,
          'arQty' : (typeof pod.qty !== 'undefined') ? pod.qty : null,
          'price' : (typeof pod.price !== 'undefined') ? pod.price : null,
          'countryOfOrigin': (typeof pod.countryOfOrigin !== 'undefined') ? pod.countryOfOrigin : null,
        }
      });
      return P3PoJson;
    }        
  }

  joinVendorAndBuyerNotes = (poDetails, buyerNote) => {
    poDetails.vendorNote = ''
    if (poDetails.ocaVendorNote && poDetails.ocaVendorNote !== '') 
      poDetails.vendorNote = poDetails.ocaVendorNote
    if (buyerNote) 
      poDetails.vendorNote = (poDetails.vendorNote !== '') ? [poDetails.vendorNote,'|',buyerNote].join(' ') : buyerNote;
  }

  handleApprove = (buyerNote = null) => {
    this.setState({ isSaving: true });
    const { selectedPurchaseOrderDetails } = this.state;
    this.joinVendorAndBuyerNotes(selectedPurchaseOrderDetails, buyerNote);
    var P3PoJson = this.formatToP3JSON(selectedPurchaseOrderDetails);
    if (P3PoJson != null) {
      logger.debug('Json send to P3 ..', JSON.stringify(P3PoJson));
      postPurchaseOrder(P3PoJson)
        .then(() => {
          this.handleDelete();
        })
        .catch(() => {
          console.log('Error on handleApprove');
          //this.handleDelete();
        });
    }
  }

  handleReject = (buyerNote = null) => {
    this.setState({ isSaving: true });
    const { selectedPurchaseOrderDetails } = this.state;
    this.joinVendorAndBuyerNotes(selectedPurchaseOrderDetails, buyerNote);
    const { currentUser } = this.props;
    if (selectedPurchaseOrderDetails !== null){
      var P3PoJson = {};
      P3PoJson.poId = selectedPurchaseOrderDetails.poId;
      P3PoJson.statusCode = 'O';
      P3PoJson.updateBuyer = currentUser;
      P3PoJson.vendorNote = selectedPurchaseOrderDetails.vendorNote;
      logger.debug('Json send to P3 ..', JSON.stringify(P3PoJson));
      postPurchaseOrder(P3PoJson)
        .then(() => {
          this.handleDelete();
        })
        .catch(() => {
          console.log('Error on handleReject');
            //this.handleDelete();
        }); 
    }   
  }

  handleDelete = () => {
    const { selectedPurchaseOrder, buyerId } = this.state;
    logger.debug('selectedPurchaseOrder...', selectedPurchaseOrder, 'buyerId...', buyerId);
    if (buyerId != null && selectedPurchaseOrder != null) {
      deletePurchaseOrder(buyerId, selectedPurchaseOrder).then(() => {
        this.setState({
          selectedPurchaseOrder: null,
          purchaseOrderItemDetails: null,
          selectedPurchaseOrderDetails: null,
          buyerId: null,
          isSaving: false
        });
        this.props.handleSearch();
      })
        .catch(() => {
          console.log('Error on Delete');
          this.setState({
            selectedPurchaseOrder: null,
            purchaseOrderItemDetails: null,
            selectedPurchaseOrderDetails: null,
            buyerId: null,
            isSaving: false
          });
          this.props.handleSearch();
        });
    }
  }

  savePurchaseOrderForBulkApprove = (poId) => {
    const { selectedPurchaseOrders } = this.state;
    const purchaseOrderId = poId.toString();

    if (selectedPurchaseOrders.includes(purchaseOrderId)) {
      const removedPurchaseOrder = selectedPurchaseOrders.filter(po => po !== purchaseOrderId );
      this.setState({ selectedPurchaseOrders: removedPurchaseOrder });
    } else {
      selectedPurchaseOrders.push(purchaseOrderId);
      this.setState({ selectedPurchaseOrders });
    }
  }

  handleFilterChange = (e) => {
    const val = e.target.value;
    const { purchaseOrderDetails } = this.props;
    
    switch (val) {
      case '0':
        this.setState({ filteredPurchaseOrders: purchaseOrderDetails, selectedFilterOption: 0, selectedPurchaseOrders: [] });
        break;
      case '1': //No Vendor Changes
        const noChanges = purchaseOrderDetails.filter(po => 'hasVendorChanges' in po && !po.hasVendorChanges);
        this.setState({ filteredPurchaseOrders: noChanges, selectedFilterOption: 1, selectedPurchaseOrders: noChanges.map(i => i.poId.toString())});
        break;
      case '2': // Vendor Changes
          const changes = purchaseOrderDetails.filter(po => !('hasVendorChanges' in po) || po.hasVendorChanges);
          this.setState({ filteredPurchaseOrders: changes, selectedFilterOption: 2});
          break;
      default:
        break;
    }
  }

  handleBulkApprove = () => {
    this.setState({ isSaving: true, showConfirmationModal: false });
    
    const { selectedPurchaseOrders } = this.state;
    const { currentUser, purchaseOrderDetails } = this.props;

    const poPromises = [];
    const poDeletePromises = [];
    let purchaseOrdersToAccept = selectedPurchaseOrders;

    // if no purchase orders are selected for Bulk Accept then we should Accept all
    // the purchase order with no vendor changes
    if (selectedPurchaseOrders.length === 0 ) {
      purchaseOrdersToAccept = purchaseOrderDetails.filter(po => 'hasVendorChanges' in po && !po.hasVendorChanges).map(po => po.poId.toString());
    }

    purchaseOrdersToAccept.forEach(poId => {
      const selectedPurchaseOrderDetails = purchaseOrderDetails.filter(po => po.poId.toString() === poId.toString())[0]
      this.joinVendorAndBuyerNotes(selectedPurchaseOrderDetails, null);
      var P3PoJson = this.formatToP3JSON(selectedPurchaseOrderDetails);    

      logger.debug('Json send to P3 ..', JSON.stringify(P3PoJson));
      const buyerId = purchaseOrderDetails.filter(po => po.poId.toString() === poId.toString())[0].buyerId;

      poPromises.push(postPurchaseOrder(P3PoJson));
      poDeletePromises.push(deletePurchaseOrder(buyerId, poId));
    });

    Promise.all(poPromises).then(() => {
      // once completed saving all the POs
      // then delete the POs from OCD
      Promise.all(poDeletePromises).then(() => {
        this.setState({ isSaving: false, selectedPurchaseOrders: [], showConfirmationModal: false });       
        // refresh the search criteria
        this.props.handleSearch(false, selectedPurchaseOrders);
      }).catch(() => {
        // delete send back errors every time so this call to delete POs from Dynamo will fail
        this.setState({ isSaving: false, selectedPurchaseOrders: [], showConfirmationModal: false });       
        // refresh the search criteria
        this.props.handleSearch(false, selectedPurchaseOrders);
      })
    });
  }

  cancelConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  }

  hideShowConfirmationModal = () => {
    const { showConfirmationModal } = this.state;
    this.setState({ showConfirmationModal: !showConfirmationModal });
  }

  render() {
    const {
      selectedPurchaseOrder,
      purchaseOrderItemDetails,
      vendorName,
      orderValidations,
      orderHeaders,
      selectedPurchaseOrders,
      filterOptions,
      filteredPurchaseOrders,
      selectedFilterOption,
      showConfirmationModal,
      isSaving
    } = this.state;

    const { purchaseOrderDetails } = this.props;

    return (
      <div>

        { isSaving
          ? <div className="flex-container-row"><Pulse text="Saving Purchase Orders..." /></div>
          : null
        }

        { isSaving
          ? null
          : <div className="flex-container-row" style={{ textAlign: 'center', paddingBottom: "10px" }}>
              <div className="flex-container-column">
                <DropDown id="filter" labelName="Filter For" options={filterOptions} value={'0'} handleChange={this.handleFilterChange} />
              </div>
              {selectedFilterOption === 1
                ? <div className="flex-container-column" style={{ paddingTop: "33px" }}>
                  <PrimaryButton onClick={() => this.hideShowConfirmationModal()} name="Approve" />
                </div>
                : null
              }
            </div>
        }

        { isSaving
          ? null
          : <div className="flex-container-row item-table-container show">
              <div className="flex-container-column">
                  <table className="item-table" cellPadding="0" cellSpacing="0" width="100%">
                      <colgroup>
                          <col span="1" style={{ width: '1%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '7%' }} />
                          <col span="1" style={{ width: '15%' }} />
                          <col span="1" style={{ width: '7%' }} />
                          <col span="1" style={{ width: '7%' }} />
                          <col span="1" style={{ width: '7%' }} />
                          <col span="1" style={{ width: '7%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                      </colgroup>
                      <tbody>
                          <tr className="item-table-header">
                              <td>&nbsp;</td>
                              <td>XPO Number </td>
                              <td>Pickup Number</td>
                              <td>Customer Name</td>
                              <td>Loading Date</td>
                              <td>New Loading Date</td>
                              <td>Arrival Date</td>
                              <td>New Arrival Date</td>
                              <td>Cooler</td>
                              <td>New Cooler</td>
                              <td>Total Cost</td>
                              <td>Total Cases</td>
                              <td>Total Weight</td>
                              <td>Total Pallets</td>
                              <td>Confirmation Note</td>
                          </tr>
                        
                      {filteredPurchaseOrders.map((item) => { 
                            const bulkApproveImage = selectedFilterOption === 1 && selectedPurchaseOrders.includes(item.poId.toString()) ? checkmark : matched;
                            const displayConfirmationNote = (item) => {
                              let confNote = ''
                              if (item.vendorNote && item.vendorNote !== null && item.vendorNote !== '')
                                confNote = item.vendorNote
                              if (item.ocaVendorNote && item.ocaVendorNote !== '')
                                confNote = (confNote !== '') ? [confNote,'|',item.ocaVendorNote].join(' ') : item.ocaVendorNote
                              return confNote
                            }
                            return (
                              <tr key={item.poId} className="item-row">
                                  <td className="bulk-approve" onClick={() => {
                                    selectedFilterOption === 1
                                    ? this.savePurchaseOrderForBulkApprove(item.poId)
                                    : this.showPurchaseOrderItems(item.poId)
                                  }}>
                                    {!('hasVendorChanges' in item) || item.hasVendorChanges
                                    ? null
                                    : <img className="matched-icon" src={bulkApproveImage} />}
                                  </td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.poId}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.pickupNumber}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{this.getCustomerName(item.customerId)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.originalLoadDate ? this.formatDate(item.originalLoadDate) : this.formatDate(item.loadDate)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{(!item.originalLoadDate || item.originalLoadDate === item.loadDate) ? null : this.formatDate(item.loadDate)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.originalArrivalDate ? this.formatDate(item.originalArrivalDate) : this.formatDate(item.arrivalDate)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{(!item.originalArrivalDate || item.originalArrivalDate === item.arrivalDate) ? null : this.formatDate(item.arrivalDate)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.originalCoolerCode}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.coolerCode !== item.originalCoolerCode ? item.coolerCode : null}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{currencyFormatter.format(item.calculatedCost)}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.calculatedCases}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.calculatedWeight ? item.calculatedWeight.toFixed(2) : ''}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{item.calculatedPallets ? item.calculatedPallets.toFixed(2) : ''}</td>
                                  <td className="item-column" onClick={() => this.showPurchaseOrderItems(item.poId)}>{displayConfirmationNote(item)}</td>
                              </tr>
                          )})}         
                      </tbody>
                  </table>
              </div>

              {selectedPurchaseOrder !== null
                ? (
                    <PurchaseOrderItemDetails
                        orderValidations={orderValidations}
                        orderHeaders={orderHeaders}
                        purchaseOrderItemDetails={purchaseOrderItemDetails}
                        purchaseOrderDetails={purchaseOrderDetails.filter((po) => po.poId.toString() === selectedPurchaseOrder.toString())[0]}
                        vendorName={vendorName}
                        poNumber={selectedPurchaseOrder}
                        closeModal={this.closeModal}
                        handleApprove={this.handleApprove}
                        handleReject={this.handleReject}
                        searchId={Math.floor(1000000 * Math.random()) * 100000000}
                    />
                ) : null}
          </div>
        }

        { showConfirmationModal
          ? <ConfirmationModal showConfirmationModal={showConfirmationModal} selectedItems={selectedPurchaseOrders} handleSave={this.handleBulkApprove} cancelConfirmationModal={this.cancelConfirmationModal} />
          : null
        }  

        </div>
    );
  }
}

export default PurchaseOrderDetails;
